import React from 'react';
import ReactDOM from 'react-dom';

import App from './main/App';

const appContainer = document.getElementById('app');

ReactDOM.render(
  <App />,
  appContainer,
);
